module.exports = __webpack_public_path__ + "img/background-homepagejobs.3838a279.jpg";